import React, { Fragment } from 'react';
import { useNavigate } from 'react-router-dom';

import { Badge } from '../../Badge/Badge';
import { formatDateTime } from '../../../utils';
import { UserInitials } from '../../UserInitials/UserInitials';
import { ComponentsCount } from '../ComponentsCount/ComponentsCount';

import type { PageListItem, UserResponse } from '../../../types';
import type { FC } from 'react';

import styles from './PageRow.module.scss';

type Props = {
  page: PageListItem;
  user?: UserResponse;
};

const getPageTaxonomy = (page: PageListItem) => {
  switch (page.type) {
    case 'category':
      return page.category;
    case 'tag':
      return page.tag;
    default:
      return null;
  }
};

export const PageRow: FC<Props> = ({ page, user }) => {
  const navigate = useNavigate();

  const taxonomy = getPageTaxonomy(page);
  const taxonomyLabel =
    page.type === 'custom' ? `/${page.slug}` : taxonomy?.title;

  const {
    id,
    meta: { title, description, keywords } = {},
    components,
    useDefaultTemplate,
  } = page;

  return (
    <tr onClick={() => navigate(`/pages/${id}`)} className={styles.row}>
      <td>
        <span className={styles.pageType}>{page.type}</span>
        <Badge>{taxonomyLabel}</Badge>
      </td>
      <td>
        {useDefaultTemplate ? (
          <span className={styles.defaultTemplate}>
            {page.type} page template
          </span>
        ) : (
          <ComponentsCount count={components.length} />
        )}
      </td>
      <td>
        {page.meta && (
          <Fragment>
            {title && (
              <Badge variant="green" title={title}>
                title
              </Badge>
            )}
            {description && (
              <Badge variant="green" title={description}>
                description
              </Badge>
            )}
            {keywords && (
              <Badge variant="green" title={keywords}>
                keywords
              </Badge>
            )}
          </Fragment>
        )}
      </td>
      <td>
        <div className={styles.updated}>
          {page.updatedAt != null && formatDateTime(page.updatedAt)}
          {user && <UserInitials user={user} className={styles.initials} />}
        </div>
      </td>
    </tr>
  );
};
